import { render, staticRenderFns } from "./discoverNorthAmerica.vue?vue&type=template&id=a4b4600a&scoped=true&"
import script from "./discoverNorthAmerica.vue?vue&type=script&lang=js&"
export * from "./discoverNorthAmerica.vue?vue&type=script&lang=js&"
import style0 from "./discoverNorthAmerica.vue?vue&type=style&index=0&id=a4b4600a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b4600a",
  null
  
)

export default component.exports